/**
 * Created by jiayanfeng on 2018/3/16.
 * 保存用户所属全部企业信息
 * 保存用户当前企业
 * 保存用户当前企业下的全部角色
 * 保存用户当前角色
 * 保存用户当前权限
 */

import {combineReducers} from "redux";
import axios from 'axios';
import {LOGIN_SUCCESS, LOGOUT_SUCCESS} from "reducers/authenticationNew";
export const Fetch_User_Enterprises_Success = "userData/Fetch_User_Enterprises_Success";
export const Fetch_User_Enterprise_Roles_Success = "userData/Fetch_User_Enterprise_Roles_Success";
export const Fetch_User_Enterprise_Roles_Privilege_Success = "userData/Fetch_User_Enterprise_Roles_Privilege_Success";
export const Set_Current_Enterprise = "userData/Set_Current_Enterprise";
export const Set_Current_Role = "userData/Set_Current_Role";
export const Fetch_User_Function_Roles_Success = "userData/Fetch_User_Function_Roles_Success";
export const Console_Page_functionRoles = "userData/Console_Page_functionRoles";


const initData ={
  currentEnterprise:-1,
  enterprises:[
  ],
  roles:[
  ],
  currentRole:-1,
  privileges:[],
  functionRoles:[]
};

/**
 * TODO:因CAS问题，暂时使用假数据调试，如需使用真实数据，
 * 请注释下方代码，采用上方代码
*/
// const initData ={
//   currentEnterprise:0,
//   enterprises:[
//   {id:"dd6d609a-3716-11e8-a97a-e266567e76d5",name:"中科云翼智能制造云服务平台",domain:"",logo:"b990dc5324fe446c84a48e3ed016672a.png"},
//   {id:"972b0cab-324e-11e8-b8d2-fa163e3164ee",name:"中国移动",domain:"mobile",logo:"b990dc5324fe446c84a48e3ed016672a.png"},
//   {id:"3",name:"中国联通",domain:"unicom",logo:"b990dc5324fe446c84a48e3ed016672a.png"},
// ],
//   roles:[
//   {id:"00000",code:"0000",name:"所有角色"},
//   {id:"00001",code:"0001",name:"管理员"},
//   {id:"00001",code:"0002",name:"用户"},
// ],
//   currentRole:0,
//   privileges:["0000001","0000002","0000003","0000004","0000005","0000006","0000007","0000008"]
// };


export function getUserEnterprisesDone(enterprise) {
  return {
    type: Fetch_User_Enterprises_Success,
    data: enterprise
  };
}
// export const getUserEnterprisesAction =(domain)=>(dispatch,getState) => {
//   axios(`/api-user/users/${getState().authentication.username}/enterprises`).then(
//     response => response.data
//   ).then(
//     enterprises => {
//       dispatch(getUserEnterprisesDone(enterprises));
//       const index =enterprises.findIndex((item)=>{
//         return item.domain === domain;
//       });
//       if(index === -1){
//         dispatch(resetUserDataAction());
//       }else {
//         dispatch(setCurrentEnterpriseAction(index));
//       }
//     }
//   );
// };
/**
 * 用户所属全部企业信息
 * 企业信息包括：企业id，企业名称，企业域名
 * @param state
 * @param action
 * @returns {Array}
 */
export function enterprises(
  state=initData.enterprises,
  // state=[],
  action){
  switch (action.type){
    case LOGIN_SUCCESS:
      return action.data.enterprises;
    case Fetch_User_Enterprises_Success:
      return action.data;
    case LOGOUT_SUCCESS:
      return [...initData.enterprises];
    default:
      return state
  }
}


function updateCurrentEnterprise(index){
  return (dispatch,getState)=>axios({
      url: `/api-user/currentEnterprise/?id=${getState().authentication.userId}&enterprise=${index}`,
      method: "POST",
      withCredentials: true
    }
  )
}

export function setCurrentEnterpriseAction(index){
  return (dispatch,getState)=>{
    dispatch(fetchEnterpriseRoles(getState().userData.enterprises[index].id));
    dispatch(updateCurrentEnterprise(index));
    dispatch({
      type:Set_Current_Enterprise,
      data:index
    })
  }
}

/**
 * 用户选择的当前企业,id,企业名称，域名
 * @param state
 * @param action
 * @returns {object}
 */
function currentEnterprise(
  state= initData.currentEnterprise,
  // state= 0,
  action){
  switch  (action.type){
    case LOGIN_SUCCESS:
      return action.data.currentEnterprise;
    case Set_Current_Enterprise:
      return action.data;
    //TODO:修改成保存currentEnterprise后需修改此处
    case Fetch_User_Enterprises_Success:
      if(action.data.length > 1){
        return 1;
      }else{
        return initData.currentEnterprise;
      }
    case LOGOUT_SUCCESS:
      return initData.currentEnterprise;
    default:
      return state;
  }
}

function fetchEnterpriseRolesDone(roles) {
  return {
    type:Fetch_User_Enterprise_Roles_Success,
    data:roles
  }
}


function fetchEnterpriseRoles(name){
  return (dispatch,getState)=>axios(`/api-user/users/${getState().authentication.userId}/enterprises/${name}/roles`).then(
    response=>response.data
  ).then(
    roles=>{
      roles.unshift({
        id:"00000000-0000-0000-0000-000000000000",
        code: "0000000",
        name: "所有角色"});
      dispatch(fetchEnterpriseRolesDone(roles));
      dispatch(setCurrentRole(0,name));
    }
  );

}




function roles(
  state=initData.roles,
  // state=[],
  action){
  switch  (action.type){
    case LOGIN_SUCCESS:
      return action.data.roles;
    case Fetch_User_Enterprise_Roles_Success:
      return action.data;
    case LOGOUT_SUCCESS:
      return [...initData.roles];
    default:
      return state;
  }
}

function setCurrentRoleEnterprise(index,name){
    return (dispatch,getState)=>{
      const {roles, enterprises, currentEnterprise} = getState().userData;
      axios({
          url: `/api-user/currentRoleEnterprise/?id=${getState().authentication.userId}&role=${index}&enterpriseId=${enterprises[currentEnterprise].id}`,
          method: "POST",
          withCredentials: true
        }
      )
    }

}

export function setCurrentRole(index,name){
  return (dispatch, getState)=>{
    dispatch(fetchEnterpriseRolePrivilege(index));
    dispatch({
      type:Set_Current_Role,
      data:index
    });
    dispatch(setCurrentRoleEnterprise(index));
    return axios({
      url: `/api-user/currentRole/?id=${getState().authentication.userId}&role=${index}`,
      method: "POST",
      withCredentials: true
    }).then(
      response => {
        console.debug("DEBUG userData setCurrentRole:", "index=>", index, "response=>", response);
      }
    )
  }
}

function currentRole(
  state=initData.currentRole,
  // state=-1,
  action){
  switch  (action.type){
    case LOGIN_SUCCESS:
      return action.data.currentRole;
    case Set_Current_Role:
      return action.data;
    case LOGOUT_SUCCESS:
      return initData.currentRole;
    default:
      return state;
  }
}

function fetchEnterpriseRolePrivilegeDone(privileges) {
  return {
    type:Fetch_User_Enterprise_Roles_Privilege_Success,
    data:privileges
  };
}
function fetchEnterpriseRolePrivilege(index){
  return (dispatch,getState)=>{
    const appName = "00000000-0000-0000-0000-000000000000";
    const userId = getState().authentication.userId;
    const {roles,enterprises,currentEnterprise} = getState().userData;
    axios(
      `/api-user/applications/${appName}/privileges?userId=${userId}&enterpriseId=${enterprises[currentEnterprise].id}&roleId=${roles[index].id}`
      // `/api-user/enterprises/${enterprises[currentEnterprise].id}/roles/${roles[index].id}/applications/${appName}/privileges?userId=${userId}`
    )
      .then(response=>response.data)
      .then(values=>{
        dispatch(fetchEnterpriseRolePrivilegeDone(values));
      })
    }
}

function privileges(
  state=initData.privileges,
  // state=[],
  action){
  switch  (action.type){
    case Fetch_User_Enterprise_Roles_Privilege_Success:
      return action.data;
    case LOGOUT_SUCCESS:
      return [...initData.privileges];
    default:
      return state;
  }
}
function functionRoles(state = [], action) {
  switch (action.type) {
    case Console_Page_functionRoles:
      return action.data;
    default:
      return state;
  }
}

const userDataReducer = combineReducers({enterprises,currentEnterprise,roles,currentRole,privileges,functionRoles}
  // headerContent,advertisements,redirectItems,
  // rapidRegs}
);
export default userDataReducer;
